export const viewTypeOptions = {
  LIST_VIEW: 'list',
  TILE_VIEW: 'tiles'
}

export const renamePlanOptions = {
  FOLDER: 'folder',
  PLAN: 'plan'
}

export const planPermissionOptions = {
  CREATE_PLAN: 'CreatePlan',
  CREATE_PLAN_FOLDER: 'CreatePlanFolder'
}

export const SEARCH_DEBOUNCE_MS = 400

export const planMenuApiErrorCodeOptions = {
  NO_PERMISSION_TO_CREATE_PLAN_OR_FOLDER: 403,
  PLAN_NAME_IS_NOT_AVAILABLE: 409,
  FOLDER_NAME_IS_NOT_AVAILABLE: 409,
  FOLDER_NO_LOGER_EXISTS: 400
}

export const planMenuItemTypeOptions = {
  PLAN: 'Plan',
  FOLDER: 'Folder'
}

export const skipRevisionChangeConfirmationKey =
  'skipRevisionChangeConfirmation'
